<template>
  <!-- 盘点弹窗 -->
  <div>
    <BaseDialog title="盘点" @handleShow="(val) => { visible = val }" :isshow="visible" width="700px" height="auto">
      <el-descriptions :column="3" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="药品名称">{{ drug.name }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ drug.medi_spec }}</el-descriptions-item>
        <el-descriptions-item label="类别">{{ drug.fee_type }}</el-descriptions-item>
        <el-descriptions-item label="生产厂家">{{ drug.company }}</el-descriptions-item>
      </el-descriptions>
      <div class="addform" style="margin-top:10px;">
        <el-form :rules="rulesForm" :model="ruleFormPd" ref="ruleFormPdRef" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="批号">
                <el-input disabled v-model="ruleFormPd.batch_no" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="盘点数量">
                <el-col :span="6">
                  换算系数 {{ drug.min_package_num }}
                </el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormPd.store_num" placeholder="">
                    <template #append>{{ drug.min_package_unit_name }}</template>
                  </el-input>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormPd.store_sub_num" placeholder="">
                    <template #append>{{ drug.min_unit_name }}</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="盘点时间：" prop="check_date">
                <el-date-picker v-model="ruleFormPd.check_date" type="date" :clearable="false" value-format="YYYY-MM-DD"
                  placeholder="请选择盘点日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="ruleFormPd.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button @click="cancelPd">取消</el-button>
        <el-button type="primary" @click="handlePd()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { downLoadXlsx, gitDictList, TimeYear } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  export default {
    components: {
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1, ctx) {
      let proxy = getCurrentInstance()
      const state = reactive({
        visible: false,
        ruleFormPd: {},//首页退货
        drug: '',
        ruleFormPdRef: null,
        rulesFormOut: {
          dict_out_type: [{ required: true, trigger: 'change', message: '请选择' },],
        },
        saveLoad:false
      })
      const initData = async (row) => {
        state.ruleFormPd = row
        state.visible = true
        state.drug = row.drug
        state.ruleFormPd.check_date = TimeYear(new Date())
      }
      
      // 盘点
      const handlePd = async () => {
        state.ruleFormPdRef.validate(async (volid) => {
          if (volid) {
            state.saveLoad = true
            state.visible = false
            let url = '/api/stockCheck/save'
            let data = {
              check_sub_num: state.ruleFormPd.store_sub_num == undefined ? '' : state.ruleFormPd.store_sub_num,
              check_num: state.ruleFormPd.store_num == undefined ? '' : state.ruleFormPd.store_num,
              record_id: state.ruleFormPd.id,
              check_date: state.ruleFormPd.check_date == undefined ? '' : state.ruleFormPd.check_date,
              remark: state.ruleFormPd.remark == undefined ? '' : state.ruleFormPd.remark
            }
            await service.post(url, data)
            state.saveLoad = false
            ctx.emit('refreshDataList', state.ruleFormPd)
            state.ruleFormPd = {}
          } else {
            return false
          }
        })

      }

      const cancelPd = () => {
        state.visible = false
        state.ruleFormPd = ''
        state.drug = ''
            }
      return {
        ...toRefs(state),
        initData,
        handlePd,
        cancelPd,
      }
    },
  }
</script>

<style scoped lang="scss">

</style>